// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XEmXw","textarea":"styles_textarea__HpoPZ"};